<template>
  <transition name="fade">
    <div class="col-span-4 col-start-4">

<!--
      <div
        v-if="!logingOut"
        class="[&_h2]:text-t5 mb-6 max-w-xl text-center"
        v-html="webapp_config.msg.welcome_msg"
      ></div>
-->
    </div>
  </transition>

    <div class="col-span-full">
      <div
        class=""
        v-if="!logingOut"
      >
        <div v-if="interestLogin" v-html="webapp_config.msg.interest_login"></div>
        <div>
          <div v-if="!loginMethod || showOnlyUsername" class="mb-5 text-center">
            <img
              class="mx-auto size-32"
              src="https://gavlegardarna.blob.core.windows.net/images/2018/01/gavle1.png"
            />
          </div>


          <LoginCiam
            v-if="loginMethod == LOGIN_METHODS.CIAM"
            @loggedIn="onLoggedIn($event)"
            @submit="onSubmit($event)"
          />

          <div v-else>
            <a :href="apiUrl + '/login/' + redirectParam" class="text-button mb-3 w-fit m-auto block rounded-[4px] bg-turquoise-60 px-6 py-3 text-white" id="loginBtn">
              Logga in
            </a>
          </div>

          <div v-if="showOnlyUsername">
            <router-link :to="{ name: 'Register' }" data-test="register-link">
              Registrera dig
            </router-link>
          </div>
          <div v-else>
            <router-link
              v-if="!loginMethod"
              :to="{ name: 'Register' }"

              data-test="register-link"
            >
              Registrera dig
            </router-link>

            <div class="mt-6 bg-primary-10 px-4 py-2 text-left" v-if="!loginMethod">
              OBS! Om du inte loggat in inom ett år blir du automatiskt rensad från vår kö.
              <br />
              <a href="/hyr-bostad/sa-gar-det-till-att-hyra-bostad/">Läs mer om våra köregler</a>
            </div>
          </div>
        </div>
      </div>

      <ajframe
        sandbox="allow-forms allow-pointer-lock allow-popups allow-same-origin allow-scripts"
        :src="XPAND_BASEURL.concat('/XpandWeb/Internet/Cm/LogonBoxView.aspx')"
        style="width: 0; height: 0; border: 0; border: none;"
        :addClasses="false"
      ></ajframe>

    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import auth from '@/auth/index';
import LoginCiam from '@/components/login/login-ciam';
import SVGImage from '@/components/login/svgimage';
import Loader from '@/components/ui/loader';
import ajframe from '@/components/ajframe';
import { XPAND_BASEURL } from '@/config';
import { LOGIN_METHODS } from '@/config/constants';
import { matchingErrorMessage } from '@/helpers';
import { dataLayerPush } from '@/helpers/datalayer';
import { API_BASEURL_V2 } from '@/config';

export default {
  components: {
    Loader,
    ajframe,
    SVGImage,
    LoginCiam,
  },
  data() {
    function ensureUrl(redirect) {
      const hasOrigion = redirect.indexOf('http') !== -1;
      if(hasOrigion) {
        return redirect;
      }

      redirect = redirect.charAt(0) === '/' ? redirect : `/${redirect}`;
      return location.origin + redirect;

    }
    return {
      LOGIN_METHODS,
      XPAND_BASEURL,
      logingOut: false,
      interestLogin: false,
      redirectURL: this.$route.query.redirect,
      showLoader : false,
      apiUrl: API_BASEURL_V2,
      redirectParam: this.$route.query.redirect ? "?returnUrl=" + ensureUrl(this.$route.query.redirect) : ''
    }
  },
  errorCaptured(err, component, info) {
    this.showLoader = false;
    if (err.response && err.response.status == 401) {
      const match = matchingErrorMessage(err);
      return false;
    }
  },
  computed: {
    ...mapGetters({
      webapp_config: 'webapp_config',
      authStatus: 'authStatus',
    }),
    showOnlyUsername() {
      return !this.webapp_config.allow_bankid_login;
    },

    loginMethod() {
//      return "ciam";
      /**
       * Har man kommit hit men bankid inte är aktiverat, visa vanliga loginen.
       */
      if (!this.webapp_config.allow_bankid_login) return LOGIN_METHODS.USERNAME_PASSWORD;

      /**
       * Använd loginmethod man angett
       */
      if (this.$route.params && this.$route.params.loginMethod)
        return this.$route.params.loginMethod;

      // ingen inloggningsmetod vald. Välj
      return;
    },
  },

  beforeMount() {
    //Check if the user wants to log out
    this.checkLogOut();
  },

  watch: {
    $route() {
      //Check if the user wants to log out
      this.checkLogOut();
    },
  },

  created() {
    if (
      this.redirectURL &&
      (this.redirectURL.indexOf('VacantResidenceDetailInterestReport') !== -1 ||
        this.redirectURL.indexOf('VacantParkingDetailInterestReport') !== -1 ||
        this.redirectURL.indexOf('VacantPremisesDetailInterestReport') !== -1)
    ) {
      this.interestLogin = true;
    }
  },

  methods: {
    mtm() {
      dataLayerPush({ event: 'losenordshantering-glomt-nytt' });
    },

    async checkLogOut() {
      const hasLogoutParam = this.$route.query.logout !== undefined;
      const isFakePathMatch = this.$route.path === "/login?logout"; // optional, this might not behave as expected

      if ((hasLogoutParam && !!!this.$route.query.logout) || isFakePathMatch) {
        this.logingOut = true;

        try {
          await this.$store.dispatch('logout');
        } catch (error) {
          console.warn("Logout error (ignoring since we allow 401):", error);
        }
      } else {
        // User is redirected to the dashboard, check auth
        if (await auth.checkAuth()) {
          this.$router.push({ name: 'Dashboard' });
        }
        this.logingOut = false;
      }
    },

    onSubmit($event) {
      this.showLoader = true;
    },
    onError() {
      this.showLoader = false;
    },
    /**
     * Denna anropas när man loggat in via någon av formulärskomponenterna
     */
    onLoggedIn() {
      // Vanliga login OK. Loggar in via SSO med.
      return this.$store
        .dispatch('loginSsoMe')
        .then(() => {
          if (this.$route.query.redirect) {
            /**
             * Kommer man från "sök ledigt" och skickats till logga in,
             * ska man skickas tillbaka till sök ledigt, vilken ligger på en annan url än mina sidor
             */
            const redirectTo = decodeURIComponent(this.$route.query.redirect);
            if (redirectTo.match(/^https?/) !== null) {
              location.href = this.$route.query.redirect;
            } else {
              this.$router.push({ path: this.$route.query.redirect }, () => {
                this.showLoader = false;
              });
            }
          } else {
            this.$router.push('/', () => {
              this.showLoader = false;
            });
          }
        })
        .catch(() => {
          this.showLoader = false;
        });
    },
  },
};
</script>
